module.exports = __webpack_public_path__ + "img/gal-11.17fa6367.jpg";